import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import IconInfo from "@assets/icons/IconInfo";
import { visibleIconDark, hiddenIconDark } from "@assets/images";

const Images = {
  visibleIcon: visibleIconDark,
  hiddenIcon: hiddenIconDark,
};
// place: bottom, top, left, right
const ToolTip = ({
  tooltipTheme = "dark",
  overrideBackground = "rgba(255,255,255, 1)",
  hoverEffect = "solid",
  messageText,
  place,
  iconContainerStyle = "",
  toolTipPopupStyle = "",
  imageKey,
  toolTipId,
  useText,
  text,
  textLimit,
  textStyle = "",
}) => (
  <div
    data-testid="tool-tip-container"
    className={`tool-tip-container ${iconContainerStyle} h-5 w-5`}
  >
    {!useText ? (
      imageKey ? (
        <img
          className="tool-tip-image w-full h-full"
          data-tip
          data-for={toolTipId}
          src={Images[imageKey]}
        />
      ) : (
        <IconInfo data-tip data-for={toolTipId} />
      )
    ) : (
      <p className={textStyle} data-tip data-for={toolTipId}>
        {text && text.length > textLimit
          ? `${text.slice(0, textLimit)}...`
          : text}
      </p>
    )}
    <ReactTooltip
      className="shadow bg-black"
      type={tooltipTheme}
      id={toolTipId}
      effect={hoverEffect}
      multiline
      delayHide={250}
      place={place ? place : "bottom"}
    >
      <div
        className={`tool-tip-message ${toolTipPopupStyle} max-w-[30rem] h-max break-words`}
        data-testid={`tool-tip-message-${toolTipId}`}
      >
        {messageText}
      </div>
    </ReactTooltip>
  </div>
);

ToolTip.propTypes = {
  /** selectable theme for tooltip */
  theme: PropTypes.oneOf([
    "dark",
    "success",
    "warning",
    "error",
    "info",
    "light",
  ]),
  /** override theme background color */
  overrideBackground: PropTypes.string,
  /** display behavior of tooltip*/
  hoverEffect: PropTypes.oneOf(["float", "solid"]),
  /** tool titp message textt */
  messageText: PropTypes.string,
  /** placement of tooltiip message*/
  place: PropTypes.oneOf(["top", "right", "bottom", "left"]),
  /** visible or hiddne tooltip icon */
  imageKey: PropTypes.oneOf(["visibleIcon", "hiddenIcon"]),
  /** styling for tooltip icon */
  iconContainerStyle: PropTypes.string,
  /** stylng for tooltip item */
  toolTipPopupStyle: PropTypes.string,
  /** tooltip id */
  toolTipId: PropTypes.string,
  /** text only tooltip hover */
  useText: PropTypes.bool,
  /** text for text only tooltip hover */
  text: PropTypes.string,
  /** tooltip text limit */
  textLimit: PropTypes.number,
  /** text style  */
  textStyle: PropTypes.string,
};

export default ToolTip;
